"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./dist/my-date-picker.module"));



//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/index.js
// module id = 464
// module chunks = 4